import React from 'react';
import PropTypes from 'prop-types';
import './PaginationDots.less';

function PaginationDots({
    maxImages,
    imageIndex,
    transitionDuration,
    inverse
}) {
    let paginationOffset = 0;

    if (imageIndex > 2 && imageIndex + 4 <= maxImages) {
        paginationOffset = -12 * (imageIndex - 2);
    } else if (imageIndex > 3) {
        paginationOffset = -12 * (maxImages - 5);
    }

    return (
        <div className={`PaginationDot  ${inverse ? 'PaginationDot--inverse' : ''}`}>
            <div className="PaginationDot__wrapper"
                style={{
                    transform: `translateX(${paginationOffset}px)`,
                    transition: `transform ${transitionDuration}ms ease-out`,
                }}
            >
                {Array(maxImages).fill().map((item, i) => {
                    return (
                        <div
                            className={`pagination-dot ${imageIndex === i ? 'pagination-dot--active' : ''}`}
                            key={`p-d-${i}`}
                            style={{
                                transition: `background-color ${transitionDuration}ms ease-out, transform ${transitionDuration}ms ease-out`,
                            }}
                        />
                    );
                })}
            </div>
        </div>
    );
}


PaginationDots.propTypes = {
    /* The number of images in this set */
    maxImages: PropTypes.number,
    /* The current index that the pagination dots should be set to */
    imageIndex: PropTypes.number,
    /** The transition duration (in milliseconds) when moving from one image index to the next or previous. Transistion occurs after click or pan. */
    transitionDuration: PropTypes.number
};

PaginationDots.defaultProps = {
    maxImages: 0,
    imageIndex: 0,
    transitionDuration: 250
};

export default PaginationDots;
